export class ArrayUtils {
	public static remove(array: any[], obj: any): any {
		const index: number = array.findIndex(m => m === obj);
		if (index !== -1) {
			array.splice(index, 1);
		}

		return array;
	}

	public static splitString(str: string, splitter: string): string[] {
		const result: string[] = [];
		if (str !== undefined) {
			str.split(splitter).forEach(k => {
				k = k.trim();
				if (k.length > 0) {
					result.push(k);
				}
			});
		}
		return result;
	}


	public static groupBy<T extends any, K extends keyof T>(array: T[], key: K | { (obj: T): number }): Record<string, T[]> {
		const keyFn = key instanceof Function ? key : (obj: T) => obj[key];
		return array.reduce(
			(objectsByKeyValue, obj) => {
				const value = keyFn(obj);
				objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
				return objectsByKeyValue;
			},
			{} as Record<number, T[]>
		);
	}
	public static groupByString<T extends any, K extends keyof T>(array: T[], key: K | { (obj: T): string }): Record<string, T[]> {
		const keyFn = key instanceof Function ? key : (obj: T) => obj[key];
		return array.reduce(
			(objectsByKeyValue, obj) => {
				const value = keyFn(obj);
				objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
				return objectsByKeyValue;
			},
			{} as Record<number, T[]>
		);
	}
}

